// Get User Profile

import { fetchApi } from '@/utils/helper';
// import { fetchWithAuth } from './authApi';

export const getUserInfo = async () => {
  try {
    const response = await fetchApi('/auth/profile');
    // console.log('User Info:', response);
    return response;
  } catch (error) {
    console.error('Lỗi khi lấy thông tin người dùng:', error);
    return null; // Tránh crash ứng dụng
  }
};
